import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
//@ts-ignore
//@ts-ignore
import { ReactComponent as PitchesLogo } from '../../graphics/pitches.svg';
//@ts-ignore
import { ReactComponent as SessionsLogo } from '../../graphics/session.svg';
import { ReactComponent as AuditLogo } from '../../graphics/audit.svg';
//@ts-ignore
import { ReactComponent as RunsLogo } from '../../graphics/runs.svg';
import { ReactComponent as AccountLogo } from '../../graphics/account.svg';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import DrawerButton from './DrawerButton';
import { Privilege } from '../../api';
import useMe from '../Util/useMe';

interface Props extends RouteComponentProps {
  classes: any;
}

const drawerWidth = 80;

const styles = (theme: any) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: '#F7F7F7',
    overflow: 'hidden',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: { height: 72 },
});

interface MenuItem {
  logo: React.ReactElement;
  title: string;
  path: string;
  prefix: string;
  privilege: Privilege;
}

const menuItems: Array<MenuItem> = [
  { logo: <PitchesLogo />, title: 'Pitches', path: '/pitch', prefix: '/pitch', privilege: Privilege.ReadPitch },
  {
    logo: <SessionsLogo />,
    title: 'Sessions',
    path: '/sessions',
    prefix: '/sessions',
    privilege: Privilege.ReadSession,
  },
  { logo: <RunsLogo />, title: 'Runs', path: '/runs', prefix: '/runs', privilege: Privilege.ReadRun },
  { logo: <AccountLogo />, title: 'Users', path: '/account', prefix: '/account', privilege: Privilege.ReadUsers },
  { logo: <AuditLogo />, title: 'Audit', path: '/audit', prefix: '/audit', privilege: Privilege.ReadAuditLogs },
];

const MainDrawer: React.FunctionComponent<Props> = (props) => {
  const classes = props.classes;
  const { data } = useMe();

  return (
    <nav>
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}>
        <div className={classes.toolbar} />
        <List>
          {menuItems
            .filter((menuItem) =>
              menuItem.privilege
                ? data?.me?.roles?.flatMap((role) => role?.privileges).includes(menuItem.privilege)
                : true
            )
            .map((menuItem, index) => (
              <DrawerButton
                key={index}
                selected={props.location.pathname.indexOf(menuItem.prefix) === 0}
                title={menuItem.title}
                logo={menuItem.logo}
                path={menuItem.path}
                onClick={() => {}}
              />
            ))}
        </List>
      </Drawer>
    </nav>
  );
};

export default withRouter(withStyles(styles)(MainDrawer));
